import NavOptionDropdownItem from "../nav/NavOptionDropdownItem";

function NavOptionDropdown({ section, sectionIndex, item, currentLanguage }) {
  return (
    <div key={sectionIndex} className="desktop-nav-dropdown">
      {section.header && (
        <div className="dropdown-header">{section.header[currentLanguage]}</div>
      )}
      {section.items.map((dropdownItem, i) => (
        <NavOptionDropdownItem
          key={`${dropdownItem.path || dropdownItem.link}-${i}`}
          dropdownItem={dropdownItem}
          currentLanguage={currentLanguage}
          itemClassName={item.className}
        />
      ))}
    </div>
  );
}

export default NavOptionDropdown;
